import React from 'react';
import {t} from 'i18next';
import AurInfographic from '../../../common/aur-infographic/AurInfographic';
import {AurInfographicCellProps} from '../../../common/aur-infographic/types';
import {STRResultKPIType} from '../ViewSTR';
import {formateNumber} from '../../../../utils/utils';
import {ReactComponent as Divider} from '../../../../assests/svg/divider-str.svg';

const stringPath = 'eca.searchTermReport.viewSTR.STRKpi.';

interface Props {
  data: STRResultKPIType;
  isDocsHitsWithRGFVisible: boolean;
}

const STRKpiContainer: React.FC<Props> = ({data, isDocsHitsWithRGFVisible}) => {
  const {
    totalNumOfTerms,
    totalDocHits,
    totalDocHitsWithRGF,
    totalDocsInSearchableSet,
    totalErrorCount,
  } = data;

  const getFormattedValue = (value?: number) => {
    /**
     * Checking value = 0 also here beacause when value is not undefine or null and value = 0 then 0 value
     * is considered false so condition will false but we need to show 0 as value. if value === 0 removed then
     * it will show -- on ui
     */
    if (value || value === 0) return formateNumber(value);
    return '--';
  };

  const kpiData: AurInfographicCellProps[] = [
    {
      primaryText: getFormattedValue(totalNumOfTerms),
      secondaryText: t(stringPath + 'field1secondaryText'),
      seperator: 'RightChevron',
    },
    {
      primaryText: getFormattedValue(totalDocHits),
      secondaryText: t(stringPath + 'field2secondaryText'),
      seperator: 'RightChevron',
      showInfoIcon: true,
      infoToolTipMsg: t(stringPath + 'uniqueDocHitTooltip'),
      infoToolTipTestId: 'unique-doc-tooltip-button',
    },
    {
      primaryText: getFormattedValue(totalDocsInSearchableSet),
      secondaryText: t(stringPath + 'field4secondaryText'),
      seperator: <Divider />,
    },
    {
      primaryText: getFormattedValue(totalErrorCount),
      secondaryText: t(stringPath + 'field5secondaryText'),
    },
  ];

  if (isDocsHitsWithRGFVisible) {
    kpiData.splice(2, 0, {
      primaryText: getFormattedValue(totalDocHitsWithRGF),
      secondaryText: t(stringPath + 'field3secondaryText'),
      seperator: 'RightChevron',
      showInfoIcon: true,
      infoToolTipMsg: t(stringPath + 'uniqueDocHitWithRGFTooltip'),
      infoToolTipTestId: 'unique-doc-with-rgf-tooltip-button',
      className: 'total-doc-with-relational-hint',
    });
  }

  return (
    <AurInfographic
      cellConfigs={kpiData}
      className="view-str-status-Kpi-container"
    />
  );
};

export default STRKpiContainer;
